<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
      ref="form"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-soccer"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingProduct"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:100"
                          name="product.code"
                        >
                          <v-text-field
                            v-model="product.isbncode"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.product.code')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|numeric"
                          vid="sku"
                          name="sku"
                        >
                          <v-text-field
                            v-model="product.sku"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.product.sku')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:500"
                          name="product.productName"
                        >
                          <v-text-field
                            v-model="product.productName"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.product.productName')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <v-text-field
                          v-model="product.brand"
                          :error-messages="errors"
                          color="secondary"
                          :label="$t('fields.product.brand')"
                          outlined
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:200"
                          name="product.descriptionShort"
                        >
                          <v-textarea
                            v-model="product.descriptionShort"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.product.descriptionShort')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="max:500"
                          name="product.descriptionShort"
                        >
                          <v-textarea
                            v-model="product.details"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.product.details')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="product.priceCost"
                        >
                          <v-text-field
                            v-model.number="product.priceCost"
                            outlined
                            name="product.priceSell"
                            :label="$t('fields.product.priceCost')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="product.priceSell"
                        >
                          <v-text-field
                            v-model.number="product.priceSell"
                            outlined
                            name="product.priceSell"
                            :label="$t('fields.product.priceSell')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|numeric"
                          name="product.inventory"
                        >
                          <v-text-field
                            v-model.number="product.inventory"
                            outlined
                            name="product.inventory"
                            :label="$t('fields.product.inventory')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="product.isAvailable"
                        >
                          <v-switch
                            v-model="product.isAvailable"
                            class="mx-2"
                            :label="$t('fields.product.isAvailable')"
                            :error-messages="errors"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="product.worksWithoutStock"
                        >
                          <v-switch
                            v-model="product.worksWithoutStock"
                            class="mx-2"
                            :label="$t('fields.product.worksWithoutStock')"
                            :error-messages="errors"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="product.categoryId"
                        >
                          <v-select
                            v-model="product.categoryId"
                            :items="productCategories"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.product.categoryId')"
                            :error-messages="errors"
                            outlined
                            @change="changeCategory(product.categoryId)"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <!-- <v-select
                          v-model="product.subCategoryId"
                          :items="productSubCategories"
                          item-text="name"
                          item-value="id"
                          :label="$t('fields.product.subCategoryId')"
                          :error-messages="errors"
                          outlined
                        /> -->
                        <v-select
                          v-model="product.subCategoryIdList"
                          :items="productSubCategories"
                          item-text="name"
                          item-value="id"
                          :label="$t('fields.product.subCategoryId')"
                          :error-messages="errors"
                          multiple
                          outlined
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <!-- <validation-provider
                          v-slot="{ errors }"
                          rules=""
                          name="product.gameLineId"
                        > -->
                        <v-select
                          v-model="product.gameLineId"
                          :items="gameLines"
                          item-text="name"
                          item-value="id"
                          :label="$t('fields.product.gameLineId')"
                          :error-messages="errors"
                          outlined
                          @change="changeGame(product.gameLineId)"
                        />
                        <!-- </validation-provider> -->
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <!-- <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="product.gameExpansionId"
                        > -->
                        <v-select
                          v-model="product.gameExpansionId"
                          :items="gameExpansions"
                          item-text="name"
                          item-value="id"
                          :label="$t('fields.product.gameExpansionId')"
                          :error-messages="errors"
                          outlined
                        />
                        <!-- </validation-provider> -->
                      </v-col>
                    </v-row>
                    <!-- sections -->
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <!-- <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="product.sections"
                        > -->
                        <v-select
                          v-model="product.sectionsId"
                          :items="sections"
                          item-text="title"
                          item-value="id"
                          :label="$t('fields.product.sections')"
                          :error-messages="errors"
                          multiple
                          outlined
                        />
                        <!-- </validation-provider> -->
                      </v-col>
                    </v-row>
                    <v-row
                      class="mx-auto"
                      justify="space-around"
                      style="max-width: 500px;"
                    >
                      <v-col
                        cols="auto"
                        class="text-center"
                      >
                        <!-- <input
                          ref="file"
                          type="file"
                          class="d-none"
                          @change="selectImage"
                        >
                        <div class="font-weight-bold grey--text">
                          Selecciona una imagen
                        </div>
                        <v-card
                          :class="imagePreview ? 'success--text' : 'grey--text'"
                          class="mx-auto mt-0 d-inline-flex v-card--account"
                          outlined
                          height="300"
                          width="300"
                          @click="$refs.file.click()"
                        >
                          <v-img
                            v-if="imagePreview"
                            :src="imagePreview"
                            height="100%"
                            width="100%"
                          />
                          <v-icon
                            v-else
                            class="mx-auto"
                            size="96"
                          >
                            mdi-account
                          </v-icon>
                        </v-card> -->
                        <div
                          id="my-strictly-unique-vue-upload-multiple-image"
                          style="display: flex; justify-content: center;"
                        >
                          <vue-upload-multiple-image
                            drag-text="Arrastrar imágenes"
                            browse-text="o click para seleccionar"
                            primary-text="Por defecto"
                            mark-is-primary-text="Establecer por defecto"
                            popup-text="Esta imagen se mostrará por defecto"
                            drop-text="Deja tus archivos aquí..."
                            :data-images="images"
                            @upload-success="uploadImageSuccess"
                            @before-remove="beforeRemove"
                            @edit-image="editImage"
                            @data-change="dataChange"
                            @mark-is-primary="markPrimary"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <v-snackbar
      v-model="showErrorMessage"
      top
      :multi-line="true"
      color="error"
    >
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showErrorMessage = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import VueUploadMultipleImage from 'vue-upload-multiple-image'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const productsRespository = repositoryFactory.get('products')
  const productCategoriesRepository = repositoryFactory.get('productCategories')
  const productSubCategoriesRepository = repositoryFactory.get('productSubCategories')
  const gameLinesRepository = repositoryFactory.get('gameLines')
  const gameExpansionsRepository = repositoryFactory.get('gameExpansions')
  const sectionsRepository = repositoryFactory.get('sections')
  const facturaPlusRespository = repositoryFactory.get('facturaPlus')

  export default {
    inject: ['theme'], // ??
    name: 'ProductCrud',
    $_veeValidate: {
      validator: 'new',
    },
    components: {
      VueUploadMultipleImage,
    },
    data: () => ({
      product: {
        isAvailable: true,
        worksWithoutStock: false,
        inventory: 0,
      },
      images: [], //  used with component
      skus: [],
      imagePreview: null,
      imageBytes: null,
      productCategories: [],
      productSubCategories: [],
      gameLines: [],
      gameExpansions: [],
      sections: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingProduct: false,
      formAction: null,
      loadingSave: false,
      errors: '',
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-product') : this.$t('modify-product')
      },
    },
    async mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingProduct = true
        var id = this.$route.params.id
        await productsRespository.getByIdBase64Images(id).then(response => {
          self.loadingProduct = false
          // self.product = Object.assign({}, response.data.data)
          self.product = response.data.data
          if (self.product.sections != null) {
            self.product.sectionsId = self.product.sections.map((x) => x.id)
          }
          if (self.product.productSubCategories != null) {
            self.product.subCategoryIdList = self.product.productSubCategories.map((x) => x.id)
          }
          if (self.product.categoryId != null) {
            this.getSubCategories(self.product.categoryId)
          }
          if (self.product.gameLineId != null) {
            this.getExpansions(self.gameLineId)
          }
          if (self.product.productImage.length > 0) {
            console.log('imagesFromApi', self.product.productImage)
            self.images = self.product.productImage
          }
        }).catch(err => {
          self.loadingProduct = false
          alert(err)
        })
      }
      await this.getCategories()
      await this.getGames()
      await this.getSections()
      await this.getSkuFacturaPlus()
    },
    methods: {
      // images
      uploadImageSuccess (formData, index, fileList) {
        console.log('uploadImagesSuccess', formData, index, fileList)
        console.log('images', this.images)
        this.imageBytes = fileList
        console.log('imageBytes', this.imageBytes)
      // Upload image api
      // axios.post('http://your-url-upload', { data: formData }).then(response => {
      //   console.log(response)
      // })
      },
      beforeRemove (index, done, fileList) {
        console.log('index', index, fileList)
        var r = confirm('¿Eliminar Imagen?')
        if (r === true) {
          this.imageBytes = fileList
          console.log('imageBytes remove', this.imageBytes)
          done()
        } else {
        }
      },
      editImage (formData, index, fileList) {
        console.log('edit data', formData, index, fileList)
        this.imageBytes = fileList
        console.log('imageBytes edited', this.imageBytes)
      },
      dataChange (data) {
        console.log('data change', data)
      },
      markPrimary (index, fileList) {
        console.log('markPrimary', fileList)
        this.imageBytes = fileList
      },
      // images-end
      submitForm (scope) {
        if (!this.isInSkus(this.product.sku)) {
          var self = this
          if (this.product.sectionsId != null) {
            this.product.sections = this.product.sectionsId.map((x) => {
              return {
                id: x,
                title: '',
              }
            })
          }
          if (this.product.subCategoryIdList != null) {
            console.log('subCategoryIdList', this.product.subCategoryIdList)
            this.product.subCategories = this.product.subCategoryIdList.map((x) => {
              return x
            })
          }

          var data = new FormData()
          data.append('data', JSON.stringify(this.product))
          if (this.imageBytes != null) {
            data.append('imageBytes', JSON.stringify(this.imageBytes))
          } else {
            data.append('imageBytes', this.imageBytes ? JSON.stringify(this.imageBytes) : null)
          }

          self.loadingSave = true
          if (self.formAction !== 'add') {
            data.append('id', this.product.id)
            productsRespository.updateProduct(data, this.product.id).then(response => {
              if (response.data.isValid) {
                self.goToList()
              } else {
                self.showErrorMessage = true
                self.errorMessage = response.data.errorMessages[0]
              }
              self.loadingSave = false
            }).catch(err => {
              self.errorMessage = err
              self.showErrorMessage = true
              self.loadingSave = true
            })
          } else {
            productsRespository.addProduct(data).then(response => {
              if (response.data.isValid) {
                self.goToList()
                self.formAction = 'modify'
              } else {
                self.showErrorMessage = true
                self.errorMessage = response.data.errorMessages[0]
              }
              self.loadingSave = false
            }).catch(err => {
              self.errorMessage = err
              self.showErrorMessage = true
              self.loadingSave = false
            })
          }
        } else {
          this.$refs.form.setErrors({
            sku: ['Este SKU ya existe'],
          })
        }
      },
      selectImage (val) {
        var self = this
        const value = val.target.files[0]
        if (!value) return (self.imagePreview = null)
        self.imagePreview = URL.createObjectURL(value)
        self.imageBytes = value
        console.log('imageBytes old', this.imageBytes)
      },
      async getCategories () {
        var self = this
        await productCategoriesRepository.get().then(response => {
          self.productCategories = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      async getSubCategories (categoryId) {
        var self = this
        await productSubCategoriesRepository.getByCategory(categoryId).then(response => {
          self.productSubCategories = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      async getGames () {
        var self = this
        await gameLinesRepository.get().then(response => {
          self.gameLines = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      async getExpansions () {
        var self = this
        await gameExpansionsRepository.get().then(response => {
          self.gameExpansions = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      async getSections () {
        var self = this
        await sectionsRepository.get().then(response => {
          self.sections = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      changeCategory (categoryId) {
        this.getSubCategories(categoryId)
        this.product.subCategoryId = null
      },
      changeGame (gameId) {
        this.getExpansions(gameId)
        this.product.gameExpansionId = null
      },
      goToList () {
        this.$router.push({ name: 'products' })
      },
      async getSkuFacturaPlus () {
        var self = this
        self.loadingSave = true
        await facturaPlusRespository.getSkuFacturaPlus().then(response => {
          if (response.data.isValid) {
            this.skus = response.data.data
          } else {
            self.showErrorMessage = true
            self.errorMessage = 'Error obteniendo lista de sku ' + response.data.errorMessages[0]
          }
          self.loadingSave = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.errorMessage = 'Error obteniendo lista de sku ' + err.response.data.errorMessages[0]
          } else {
            self.errorMessage = 'Error obteniendo lista de sku ' + err
          }
          self.loadingSave = false
        })
      },
      isInSkus (val) {
        if (this.formAction !== 'add') {
          var index = this.skus.indexOf(val)
          if (index > -1) {
            this.skus.splice(index, 1)
          }
        }
        return this.skus.includes(val)
      },

    },
  }
</script>
